import React from "react";
import Skeleton from "react-loading-skeleton";
import { View } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Skeletons from "./Skeletons";

const HomeCardSkeleton = () => {
  const deviceSize = useDeviceSize();
  let skeletonCards = Array(7).fill(0);

  return (
    <View
      style={{
        flexDirection: "row",
        marginTop: 20,
        marginBottom: 30,
        // gap:
        //   deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
        //     ? 20
        //     : 0,
        gap: 20,
      }}
    >
      {skeletonCards.map((_, index) => (
        <View
          key={index}
          style={{
            width:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 310
                : 470,
            marginLeft:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 20
                : 0,
          }}
        >
          <Skeletons
            height={
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 200
                : 250
            }
            style={{
              marginTop: 5,
              borderRadius: 10,
            }}
          />
        </View>
      ))}
    </View>
  );
};

export default HomeCardSkeleton;
